import React, { Component } from 'react';
import { connect } from 'react-redux';
import GeckoPagination from 'services/gecko-pagination';
import GeckoLocation from 'services/gecko-location';
import {
  GeckoCardTable,
  GeckoModalService,
  GECKO_CONSTS,
  GeckoToastService,
  GeckoDialogService,
} from 'ui';
import EditModal from './EditModal.jsx';
import GeckoDate from 'services/gecko-date';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';
import { convertFromRaw, EditorState } from 'draft-js';

export class SavedReplies extends Component {
  cols = [
    {
      key: 'name',
      name: 'Name',
      width: '30%',
      sortable: true,
    },
    {
      key: 'contents',
      name: 'Preview',
      width: '30%',
      render: (contents) =>
        contents.length > 50 ? `${contents.substring(0, 50)}...` : contents,
      sortable: true,
    },
    {
      key: 'assigned_team_ids',
      name: 'Available To',
      width: '30%',
      render: (assigned_team_ids) => {
        const assignedTeamNames =
          assigned_team_ids &&
          this.props.teams.length > 0 &&
          assigned_team_ids
            .map((id) => this.props.teams.find((team) => team.id === id)?.name)
            .join(', ');
        return assignedTeamNames || '- ';
      },
    },
    {
      key: 'createdAt',
      name: 'Created On',
      width: '10%',
      render: (date) => new GeckoDate(date).LONG,
      sortable: true,
    },
    {
      type: GECKO_CONSTS.TABLE_CELL_TYPE_DROPDOWN,
      width: '10%',
      items: [
        {
          name: 'Edit',
          handler: (reply) => this.editReply(reply),
        },
        {
          name: 'Remove',
          handler: (reply) => this.removeReply(reply),
        },
      ],
    },
  ];

  headerBtns = [
    {
      name: 'Add New',
      icon: 'far fa-plus',
      type: GECKO_CONSTS.BTN_TYPE_PRIMARY,
      handler: () => this.editReply(),
    },
  ];

  editReply(reply) {
    new GeckoModalService()
      .open(() => <EditModal reply={reply} />, { backdrop: 'static' })
      .then((result) => {
        if (!result) {
          return null;
        }
        if (reply) {
          return GeckoRequest.post(`/saved-replies/${reply.id}`, result);
        } else {
          return GeckoRequest.post(`/saved-replies`, result);
        }
      })
      .then((newReply) => {
        if (newReply === null) {
          return;
        }
        const isNew = Boolean(reply);
        new GeckoToastService().success(
          isNew
            ? 'Saved Reply successfully updated'
            : 'Saved Reply successfully created'
        );
      })
      .catch(renderError);
  }

  removeReply(reply) {
    return new GeckoDialogService()
      .confirm('Are you sure you want to remove this Saved Reply?')
      .then((confirm) => {
        if (confirm) {
          GeckoRequest.delete(`/saved-replies/${reply.id}`)
            .then(() => {
              new GeckoToastService().success('Saved Reply removed');
            })
            .catch(renderError);
        }
      })
      .catch(() => {});
  }

  onSearch(term) {
    GeckoLocation.goTo(
      '/settings/savedreplies',
      Object.assign({}, this.props.params, { search: term })
    );
  }

  render() {
    let [replies, pagination] = GeckoPagination.paginate({
      page: this.props.params.page,
      order_by: this.props.params.order_by,
      searchTerm: this.props.params.search,
      searchKey: 'name',
      sort: this.props.params.sort,
      changeOrder: (key) => {
        if (key !== this.props.params.order_by) {
          return GeckoLocation.goTo(GeckoLocation.location.pathname, {
            ...GeckoLocation.params,
            order_by: key,
            sort: 'ASC',
          });
        }
        return GeckoLocation.goTo(GeckoLocation.location.pathname, {
          ...GeckoLocation.params,
          order_by: key,
          sort: this.props.params.sort === 'ASC' ? 'DESC' : 'ASC',
        });
      },
    })(this.props.replies);
    if (replies) {
      replies = replies.map((r) => {
        let newR;
        if (r.contents && !r.editor_object) {
          newR = Object.assign(r, { editor_object: null });
        } else if (r.editor_object) {
          newR = Object.assign(r, {
            contents: EditorState.createWithContent(
              convertFromRaw(r.editor_object)
            )
              .getCurrentContent()
              .getPlainText(),
          });
        }
        return newR;
      });
    }

    const newLinkHandler = !this.props.replies?.length
      ? () => this.editReply()
      : undefined;
    const alert = this.props.replies?.length
      ? 'There are no results to show.'
      : 'You have not created any Saved Replies yet.';
    return (
      <div className="Replies content-margin">
        <GeckoCardTable
          name="Saved Replies"
          headerBtns={this.headerBtns}
          rows={replies}
          cols={this.cols}
          rowHandler={this.editReply.bind(this)}
          pagination={pagination}
          newLinkHandler={newLinkHandler}
          alert={alert}
          onSearch={this.onSearch.bind(this)}
          headerProps={{ searchPlaceholder: 'Search saved replies' }}
        ></GeckoCardTable>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    replies: state.saved_replies,
    params: Object.keys(state.location.params).length
      ? state.location.params
      : { sort: 'ASC', order_by: 'name' },
    teams: state.teams,
  };
};

export default connect(mapStateToProps)(SavedReplies);
